import React from 'react';
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import {Link} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Link/Link";

export const CollectionList = ({ settings }) => {
    const { section, blocks } = settings;
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    if (section.render_type !== 'all') {
        if (isMobile && section.render_type !== 'mobile-only') return null;
        if (!isMobile && section.render_type !== 'desktop-only') return null;
    }

    return (
        <div className={`color-${section.color_schema}`}>

            <div
                className={`section-collection-list-${section.id} flex ${section.reveal_animation_class} ${section.container_type} lg:justify-${section.content_position_desktop} pt-[${section.padding_top_mobile}px] lg:pt-[${section.padding_top_desktop}px] pb-[${section.padding_bottom_mobile}px] lg:pb-[${section.padding_bottom_desktop}px] px-[${section.padding_left_right_mobile}px] lg:px-[${section.padding_left_right_desktop}px]`}
            >
                <div className={`flex flex-col w-full lg:max-w-[${section.content_width}]`}>
                    <h2 className="text-center mb-8">{section.section_title}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {blocks.map((block, index) => {
                            if (block.type === 'collection') {
                                const { collection, image, collection_title, collection_subtitle } = block.settings;

                                return (
                                    <div key={index} className="collection-item flex flex-col items-center text-center">
                                        <div className="w-full mb-4">
                                            {image ? (
                                                <img src={image} alt={collection.title} className="w-full h-auto" />
                                            ) : (
                                                <img src={block.collection.image} alt={collection.title} className="w-full h-auto" />
                                            )}
                                        </div>
                                        <div className={'collection-info flex w-full'}>
                                            <div className={'basis-1/2 items-start text-left'}>
                                                <h3 className="mb-2">{collection_title}</h3>
                                                <p className="mb-4">{collection_subtitle}</p>
                                            </div>
                                            <div className={'basis-1/2 justify-end items-end self-end'}>
                                                <Link link={`/collections/${collection}`} classes={'button button-primary'}>
                                                    See All {collection_title}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>

                    <div className="collection-cta flex gap-x-[16px] items-center self-center pt-[40px]">
                        {blocks.map((block, index) => {
                            if (block.type === 'cta') {
                                const { button_text, button_url, button_style } = block.settings;
                                return (
                                    <div key={index} className="collection-cta-item">
                                        {button_text && button_url && (
                                            <a href={button_url} className={`button ${button_style}`}>
                                                {button_text}
                                            </a>
                                        )}
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
